export const BOOKING_INIT_STEP = "BOOKING_INIT_STEP";
export const BOOKING_GOTO_STEP = "BOOKING_GOTO_STEP";
export const BOOKING_NEXT_STEP = "BOOKING_NEXT_STEP";
export const BOOKING_PREV_STEP = "BOOKING_PREV_STEP";

export const BOOKING_INFO_GUEST_INFO_INIT = "BOOKING_INFO_GUEST_INFO_INIT";
export const BOOKING_INFO_GUEST_INFO_CHANGE = "BOOKING_INFO_GUEST_INFO_CHANGE";
export const BOOKING_INFO_REMARKS_CHANGE = "BOOKING_INFO_REMARKS_CHANGE";

export const BOOKING_INFO_PAYMENT_INTENT_RESET =
  "BOOKING_INFO_PAYMENT_INTENT_RESET";
export const BOOKING_INFO_PAYMENT_INTENT_SAVE =
  "BOOKING_INFO_PAYMENT_INTENT_SAVE";
export const BOOKING_INFO_PAYMENT_CHECKOUT_SAVE =
  "BOOKING_INFO_PAYMENT_CHECKOUT_SAVE";
export const BOOKING_INFO_PAYMENT_CHECKOUT_RESET =
  "BOOKING_INFO_PAYMENT_CHECKOUT_RESET";
export const BOOKING_INFO_PAYMENT_LOADING = "BOOKING_INFO_PAYMENT_LOADING";
export const BOOKING_INFO_PAYMENT_IDLE = "BOOKING_INFO_PAYMENT_IDLE";
export const BOOKING_INFO_PAYMENT_RESULT_SAVE =
  "BOOKING_INFO_PAYMENT_RESULT_SAVE";
export const BOOKING_INFO_BOOKING_RESULT_SAVE =
  "BOOKING_INFO_BOOKING_RESULT_SAVE";
export const BOOKING_INFO_LOAD_STATE = "BOOKING_INFO_LOAD_STATE";
